import React from 'react';
import PropTypes from 'prop-types';
import DateUtils from '../../utilities/date-utils';
import Constants from '../../constants/Constants';
import Messages from '../../constants/Messages';

/**
 * Component to show a Transaction
 * @param {*} props 
 * @returns 
 */
const TransactionItem = (props) => {
    const { 
        transactionDate, 
        amount, 
        description,
        transactionType,
        payerDetails = undefined
    } = props && props.data;
    
    let highlightColor = '';
    let transactionSymbol = '';
    if(transactionType === Constants.TRANSACTION_TYPE.CREDIT) {
        highlightColor = 'text-green-700';
        transactionSymbol = "+";
    } else if(transactionType === Constants.TRANSACTION_TYPE.DEBIT) {
        highlightColor = 'text-red-600';
        transactionSymbol = "-";
    }
    
    return (
        <div className="flex w-full p-4 mt-1 text-xs rounded-lg bg-white align-items">
            <div className="basis-2/6">
                { `${DateUtils.getDateInISTFormat(transactionDate)}, ${DateUtils.getTimeInISTFormat(transactionDate)} `}
            </div>
            <div className="basis-3/6">
                { payerDetails ? `${payerDetails.employeeName} (${payerDetails.employeeId})` : description }
            </div>
            <div className="basis-1/6 text-right flex-end font-bold">
                <span className = {highlightColor}>{transactionSymbol} {Messages.CURRENCY.INR} {amount}</span>
            </div>
        </div>
    )
}

TransactionItem.propTypes = {
    transactionDate : PropTypes.string, 
    amount : PropTypes.number, 
    description : PropTypes.string,
    transactionType : PropTypes.string,
    payerDetails : PropTypes.object
};

export default TransactionItem;





